export default __webpack_public_path__ + "static/media/ViberantLogo.de75d91a.png";